module.exports = "https://s81616.cdn.ngenix.net/microcredits-frontend/_next/static/images/fullDeal-9b65abc7031de935efe7a9d7c4205ea6.png";